import moment from 'moment';

export default class DateUtils {
	static FORMAT_yyyy_MM_dd = 'YYYY-MM-DD';
	static FORMAT_MMM_Do_YYYY = 'MMM Do YYYY';

	static convertUTCDateToLocalDate(date) {
		var time = moment.utc(date)
		var local = time.format('h:mm A')
		return (local);
	}
	static convertUTCDateToLocalDateWithoutTime() {
		var local = this.getCurrentDate('YYYY-MM-DD');
		// var gmtDateTime = new Date(date);
		// var local = gmtDateTime.format('YYYY-MM-DD');
		
		return local;
	}
	static getCurrentDate = dateFormat => {
		return moment().format(dateFormat);
	};
	// This function will calculate percentage of remaining days over remaining days and +1 is added to include end date as well
	static calculateRemainingDaysPercentage = (
		startDate,
		endDate,
		daysRemaining,
	) => {
		var start = moment(startDate);
		var end = moment(endDate);

		var totalDays = end.diff(start, 'days') + 1;
		var remainingPercentage = (daysRemaining / totalDays) * 100;
		return remainingPercentage;
	};

	//This function will convert format of a date as per passed DateFormat
	static convertDateFormat(sourceDate, sourceDateformat, targetDateformat) {
		return moment.parseZone(sourceDate, sourceDateformat).format(targetDateformat)
		//return moment(sourceDate, sourceDateformat).format(targetDateformat);
	}

	//This function will convert format of a date as per passed DateFormat to local timezone.
	static convertDateFormatToLocalTimezone(sourceDate, targetDateformat) {
		return moment(sourceDate).format(targetDateformat)
		//return moment(sourceDate, sourceDateformat).format(targetDateformat);
	}

	static convertMillisToLocalTimezone(millis, targetDateformat) {
		return moment(millis).format(targetDateformat) //parse integer
	}

	//This function will set mins and secs to zero and will return same date in same format.
	static getDateWithZeroMinsSeconds(sourceDate, sourceDateformat) {
		const momentObj = moment(sourceDate, sourceDateformat);
		momentObj.set({ minutes: 0, seconds: 0 });
		return momentObj.format(sourceDateformat)
	}

	//This function will add no of days as passed and will return a formated date
	static addNoOfDaysToDate(date, dateFormat, noOfdays) {
		return moment(date, dateFormat)
			.add(noOfdays, 'days')
			.format(dateFormat);
	}

	//This function will subtract no of days as passed and will return a formated date
	static subtractNoOfDaysFromDate(date, dateFormat, noOfdays) {
		return moment(date, dateFormat)
			.subtract(noOfdays, 'days')
			.format(dateFormat);
	}

	static subtractMonthFromDate(date, dateFormat) {
		return moment(date, dateFormat)
			.subtract(1, 'months')
			.format(dateFormat);
	}

	static getDateRangeForHistory(minDate, maxDate, selectedDate, count) {
		var startDate = moment(selectedDate).format("YYYY-MM-DD")
		var endDate = undefined

		var dateList = []

		var minDateMoment = moment(minDate)
		var maxDateMoment = moment(maxDate)
		var selectedDateMoment = moment(selectedDate)

		var now = selectedDateMoment.clone()
		while (now.isSameOrBefore(maxDateMoment) && dateList.length < count) {
			dateList.push(now.format("YYYY-MM-DD"))
			now.add(1, 'days');
		}

		endDate = dateList[dateList.length - 1]

		now = selectedDateMoment.clone()
		now.subtract(1, 'days');

		var tempDateList = []
		if (dateList.length < count) {
			while (now.isSameOrAfter(minDateMoment) && dateList.length < count) {
				dateList.push(now.format("YYYY-MM-DD"))
				tempDateList.push(now.format("YYYY-MM-DD"))
				now.subtract(1, 'days');
			}
		}

		if (tempDateList.length > 0) {
			startDate = tempDateList[tempDateList.length - 1]
		}

		var dateRange = {
			startDate: startDate,
			endDate: endDate
		}

		return dateRange
	}

	static getListOfDatesBetweenDates(startDt, startDateFormat, endDt, endDateFormat, destinationFormat) {
		var datesList = []

		let startDate = moment(startDt, startDateFormat);
		let endDate = moment(endDt, endDateFormat);

		var now = startDate.clone()

		while (now.isSameOrBefore(endDate)) {
			datesList.push(now.format(destinationFormat));
			now.add(1, 'days');
		}

		var todaysHour = moment().format("HH")
		if (todaysHour < 6 && datesList.length > 0) {
			datesList = datesList.splice(0, datesList.length - 1);
		}

		return datesList.reverse()
	}

	static getYearsOfBirth(currentYear) {
		var minimumYear = currentYear - 18;
		var yearsOfBirth = [];
		for (var index = 0; index <= 132; index++)
			yearsOfBirth.push("" + (minimumYear - index));
		return yearsOfBirth;
	}

	static getDifferenceBetweenDates(startDate, endDate, dateFormat, timeUnitMoment) {
		var startTimeObj = moment(startDate, "yyyy-MM-DD hh:mm:ss Z");
		var endTimeObj = moment(endDate, "yyyy-MM-DD hh:mm:ss Z");
		var timeDiff = endTimeObj.diff(startTimeObj, timeUnitMoment);
		return timeDiff;
	  }
	
	static getDateOrdinal(date) {
		return moment(date).format("Do")
	}
}
